import { BaseMapper } from '@ps/utils';

import { ReportDto } from '../dtos/report.dto';
import { Report, ReportStatus } from '../../models/report.model';

export class ReportMapper extends BaseMapper<ReportDto, Report> {
  private readonly _reportStatusValues: ReadonlySet<number> = new Set(
    Object.values(ReportStatus).filter(
      (value): value is number => typeof value === 'number',
    ),
  );

  public fromDto(reportDto: ReportDto): Report {
    return {
      reportId: reportDto.reportId,
      filename: reportDto.filename,
      type: reportDto.type ?? '',
      status: this._toReportStatus(reportDto.reportStatus),
      startDate: reportDto.reportStartDate,
      endDate: reportDto.reportEndDate,
      requestedAt: this._toTimestamp(reportDto.requestedTimestamp),
      createdAt: reportDto.crtdOn,
    };
  }

  private _toTimestamp(value: number | string): number {
    return typeof value === 'string' ? new Date(value).getTime() : value;
  }

  private _toReportStatus(value: number): ReportStatus {
    if (this._reportStatusValues.has(value)) {
      return value as ReportStatus;
    }
    return ReportStatus.Pending;
  }
}
